import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Card, CardContent } from '@paulownia/shared/components/ui/card';
import {
  getMarketTenantsForDisplay,
  getMarketById,
  type Market,
} from '@paulownia/shared';

interface CrossSellCTAProps {
  marketId: string | undefined;
}

/**
 * Cross-sell CTA shown after order confirmation
 * Displays a link to discover merchants at the same market
 */
export function CrossSellCTA({ marketId }: CrossSellCTAProps) {
  const [count, setCount] = useState<number | null>(null);
  const [market, setMarket] = useState<Market | null>(null);

  useEffect(() => {
    if (!marketId) return;

    // Fetch all merchants count and market info in parallel
    Promise.all([
      getMarketTenantsForDisplay(marketId),
      getMarketById(marketId),
    ]).then(([tenants, marketData]) => {
      setCount(tenants.length);
      setMarket(marketData);
    });
  }, [marketId]);

  // Don't render if no market, still loading, or no merchants
  if (!marketId || count === null || count === 0 || !market) {
    return null;
  }

  return (
    <Link to={`/market/${marketId}`} className="block mb-4">
      <Card className="mt-4 bg-orange-50 border-orange-200 hover:bg-orange-100 transition-colors">
        <CardContent className="p-4 flex items-center justify-between">
          <div>
            <p className="font-medium text-gray-900">
              Continuez vos achats au marché
            </p>
            <p className="text-sm text-muted-foreground">
              {count} commercant{count > 1 ? 's' : ''} a {market.city}
            </p>
          </div>
          <ChevronRight className="h-5 w-5 text-orange-600 flex-shrink-0" />
        </CardContent>
      </Card>
    </Link>
  );
}
